import { render, staticRenderFns } from "./Forget.vue?vue&type=template&id=1c5655ec&scoped=true"
import script from "./Forget.vue?vue&type=script&lang=js"
export * from "./Forget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5655ec",
  null
  
)

export default component.exports